<template>
  <div>
    <div class="l-container">
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getTutorsupports()
      vm.getUsersSelect()
      vm.getTags()
      vm.getOffices()
    })
  },
  methods: {
    // getTutorsupports () {
    //   this.$store.dispatch('getTutorsupports')
    // },

    getUsersSelect () {
      this.$store.dispatch('getUsersSelect')
    },

    getTags () {
      this.$store.dispatch('getTags')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// Tutorsupports.vue?6dc099dd